import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseService } from './base.service';

@Injectable({
  providedIn: 'root',
})
export class ProductService {
  constructor(private baseService: BaseService) {}

  createProduct(data: any): Observable<any> {
    return this.baseService.post('product/addProduct', data);
  }

  updateProduct(data: any): Observable<any> {
    return this.baseService.patch(
      `product/editProduct/${data?.productId}`,
      data
    );
  }

  getAllProducts(): Observable<any> {
    return this.baseService.get('product/listProducts');
  }

  getProductById(data: any): Observable<any> {
    return this.baseService.get('product/getProduct', data);
  }

  deleteProduct(data: any): Observable<any> {
    return this.baseService.delete('product/delete', data);
  }

  getCategoryWiseProducts(data: any): Observable<any> {
    return this.baseService.get(`product/listProductsCategorywise/${data}`);
  }

  setProductOutofStock(data: any): Observable<any> {
    return this.baseService.patch(
      `product/setProductOutOfStock/${data.productId}`,
      data.inStock
    );
  }

  addBatchQuantity(data: any): Observable<any> {
    return this.baseService.post('batch/createBatch', data);
  }

  getAllBatches(): Observable<any> {
    return this.baseService.get('batch/listbatches');
  }

  getClaimedProducts(search: string = ''): Observable<any> {
    const url = search ? `registeredProducts/getClaimedProducts?search=${encodeURIComponent(search)}` : 'registeredProducts/getClaimedProducts';
    return this.baseService.get(url);
  }

  getAllRegisteredProducts(search: string = '', page: number = 1, limit: number = 10): Observable<any> {
    let url = `registeredProducts/getAllRegisteredProducts?page=${page}&limit=${limit}`;
    if (search) {
      url += `&search=${encodeURIComponent(search)}`;
    }
    return this.baseService.get(url);
  }

  createMasterBatch(data: any): Observable<any> {
    return this.baseService.post('masterBatch/create', data);
  }

  getAllMasterBatches(): Observable<any> {
    return this.baseService.get('masterBatch/list');
  }

  getMasterBatchDetail(id: string): Observable<any> {
    return this.baseService.get(`masterBatch/${id}`);
  }

  getMasterBatchStatus(id: string): Observable<any> {
    return this.baseService.get(`masterBatch/status/${id}`);
  }

  assignBatchToProduct(data: any): Observable<any> {
    return this.baseService.post('masterBatch/assignToProduct', data);
  }

  updateMasterBatch(id: string, data: any): Observable<any> {
    return this.baseService.put(`masterBatch/${id}`, data);
  }

  deleteMasterBatch(id: string): Observable<any> {
    return this.baseService.delete('masterBatch', id);
  }
}

